<template>
  <div
    class="fixed bottom-0 right-0 w-87 flex justify-center items-center z-10 mr-3 mb-6 cursor-pointer"
    @click="moveTo(1)"
  >
    <img :src="`${imgPath}/slide1/top_btn.png`" />
  </div>
</template>

<script>
export default {
  props: {
    moveTo: Function,
  },
  data: function() {
    return {
      imgPath: process.env.VUE_APP_IMG_URL,
    };
  },
};
</script>

<style></style>
